import { type ApiListResponse } from "./shared";

import { type RawNavItem } from "@/components/layout/Sidebar/utils/NavItems";
import { authenticatedBitswanBackendInstance } from "@/lib/api-client";

export type Profile = {
  id: string;
  name: string;
  nav_items: RawNavItem[];
};

export type ProfileListResponse = ApiListResponse<Profile>;

export const fetchProfiles = async (
  { pageParam = 1, orgId }: { pageParam?: number; orgId: string },
) => {
  const bitswanBEInstance = await authenticatedBitswanBackendInstance();

  const res = await bitswanBEInstance.get<ProfileListResponse>(
    `/profiles/`,
    {
      params: {
        page: pageParam,
      },
      headers: {
        "X-Org-Id": orgId,
      },
    },
  );
  return { ...res.data, status: "success" as const };
};
